const { formatDate, formatNumber, formatEmail, validateForm } = require("./form/validator.js");

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';

(function ($) {

    var msg = { "default": "Send", "processing": "Sending...", "success": "Message Sent", "error": "Something Wrong" };

    function requestAQuoteForm() {

        var form = $("#" + form_id);

        var fields = $("#" + form_id + " input , #" + form_id + " select, #" + form_id + " textarea");

        var inputTitles = {};

        fields.each(function (i, e) {
            if ($(e).attr('type') === 'text' || $(e).get(0).nodeName === 'TEXTAREA') {
                inputTitles[$(e).attr('name')] = $(e).attr('placeholder');
            }
            if ($(e).get(0).nodeName === 'SELECT') {
                inputTitles[$(e).attr('name')] = $(e).find('option').eq(0).html();
            }
        });

        if (validateForm(form, true, null)) {

        let serializedInputs = form.serialize();

        $.ajax({
            url: request_a_quote.url,
            type: "POST",
            data: {
                inputs: serializedInputs,
                fields: inputTitles
            },
            dataType: "json",
            beforeSend: function () {
                $('section#request-a-quote form .wp-block-buttons .wp-block-button a').html(msg.processing);
                $('section#request-a-quote form .wp-block-buttons .wp-block-button a').addClass('disabled');
            },
            success: function (res) {
                // console.log(res);
                if (res) {

                    let response = JSON.parse(res);

                    if (response.success) {
                        $('section#request-a-quote form .wp-block-buttons .wp-block-button a').html(msg.success);
                    }
                    if (response.error) {
                        $('section#request-a-quote form .wp-block-buttons .wp-block-button a').html(msg.error);
                    }

                    console.log(res);
                    // window.location = data.checkout.url;
                }
            }
        })
        }

    }

    $(document).ready(function () {

        if (typeof form_id != 'undefined') {

            const birthDate = new AirDatepicker('input.date', {
                locale: localeEn
            });

            let minHours, maxHours = 0;

            if ($('input.date-time').attr("data-input")) {
                const [min, max] = $('input.date-time').attr("data-input").split(",");
                minHours = min;
                maxHours = max;
            }


            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            tomorrow.setHours(minHours);
            tomorrow.setMinutes(0);

            const dateHour = new AirDatepicker('input.date-time', {
                locale: localeEn,
                timepicker: true,
                minHours: minHours,
                maxHours: maxHours,
                minutesStep: 5,
                minDate: tomorrow,
                utc: true
            });


            $("#" + form_id + " .paragraph-custom-view__ > p > a").click(function (e) {
                // e.preventDefault();
            });

            $("#" + form_id + " .wp-block-button__link").click(function (e) {
                e.preventDefault();
                requestAQuoteForm();
            });

            $("#" + form_id).submit(function (e) {
                e.preventDefault();
                requestAQuoteForm();
            });

            // $("input[name='birth_date']").keyup(function () {
            //     formatDate($(this));
            // });

            $("input[name='phone_number']").keyup(function () {
                formatNumber($(this),10);
            });

            $("input[name='zip_code']").keyup(function () {
                formatNumber($(this),5);
            });

            $("input[name='email']").keyup(function () {
                formatEmail($(this));
            });

            $("input,textarea,select").focus(function (e) {
                $(this).removeClass("error");
                $(this).parent().removeClass("error");
                $(this).next("svg").remove();

                $('section#request-a-quote form .wp-block-buttons .wp-block-button a').html(msg.default);
                $('section#request-a-quote form .wp-block-buttons .wp-block-button a').removeClass('disabled');

            });

            if (typeof cancel_session != 'undefined') {
                for (const key in data) {
                    $("[name='" + key + "']").val(data[key]);

                }
                dateHour.selectDate($('input.date-time').val());
                birthDate.selectDate($('input.date').val());
            }
        }


    });


})(jQuery)